import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import {
	usePsfPromoteOrSharePageData,
	usePsfPromoteOrSharePageState,
} from '#src/app/pages/psf/promoteOrShare/pageContext';

import { useAvailablePaymentMethods, usePromoteFormState } from '../../../../formContext';

type Result = ModelHookResult<
	{
		moreWaysExpanded: boolean;
		stripeWalletPaymentsEnabled: boolean;
		isMoreWaysToPayLink: boolean;
	},
	{
		clickMoreWays: () => void;
	}
>;

export function usePaymentMethods(): Result {
	const {
		data: { promoteShareOnComboExperiment },
	} = usePsfPromoteOrSharePageData();
	const [, { setMoreWaysExpanded: setPageMoreWaysExpanded }] = usePsfPromoteOrSharePageState();
	const { paymentMethods } = useAvailablePaymentMethods();
	const [{ moreWaysExpanded }, { setMoreWaysExpanded }] = usePromoteFormState();
	const track = useTracking();

	const clickMoreWays = useCallback(() => {
		void track('pp_click_more_ways');
		setMoreWaysExpanded(true);
		// Keeping form state in sync with page state to prevent errors.
		setPageMoreWaysExpanded(true);
	}, [setMoreWaysExpanded, setPageMoreWaysExpanded, track]);

	return {
		data: {
			stripeWalletPaymentsEnabled: paymentMethods.includes('applePay') || paymentMethods.includes('googlePay'),
			moreWaysExpanded,
			isMoreWaysToPayLink: promoteShareOnComboExperiment.variation === 'variant_2',
		},
		actions: {
			clickMoreWays,
		},
	};
}
